import React from "react";
import Header from "../Landingpagecomponents/Header/header"
import { Grid, Typography, Paper, InputLabel } from "@material-ui/core";
import Footer from "../Landingpagecomponents/Footer/Footer"

const HowToGetStarted = () => {
    return(
        <Grid container style={{backgroundColor: "#eaeaea"}}>
            <Header/>
            <Grid xs={12} style={{backgroundColor: "#002D55", height: 250}} />
            <Grid container justify="center" style={{marginTop: 20}}>
            <Paper item xs={12}  style={{width: "70%", margin: 20, padding: 20}}>
                    <Typography style={{color: "#002D55"}}>
                        <h1>How to get started after completing online evaluation of symptoms</h1>
                        <h2 style={{color: "#002D55"}}>Which patients and symptoms are suitable for virtual physiotherapy?</h2>
                        <p>
                        Great! Let's get you started with our virtual physiotherapy service. First Check your email and click the verification link. This will create an user and redirect you to your new patient profile. Here you will need to select a new secure and personal password. From here you will be able to learn about your symptoms and begin your physiotherapeutic rehabilitation plan.
                        </p>
                        <h2 style={{color: "#002D55"}}>When should you see a doctor instead?</h2>
                        <p>
                            text
                        </p>                       
                    </Typography>
                </Paper>
            </Grid>
        <Grid xs={12} container justify="center" justifyContent="center">
            <Footer />
        </Grid>
        </Grid>
        );
    };

export default HowToGetStarted;